import { createReducer } from "@reduxjs/toolkit";
import initialState from "./initialState";
// import moment from "moment";
// import _ from 'lodash';
import * as types from "../types/actions";

const rentalReducer = createReducer(initialState.rental, {
  [types.RENTAL_LOGOUT]: () => initialState.rental,
  [types.RENTAL_LOGIN]: () => ({
    loading: true,
  }),
  [types.RENTAL_LOGIN_SUCCESS]: (state, action) => ({
    ...state,
    login: "success",
    rentalVehicle: action.response?.data.vehicle,
    token: action.response?.data.token,
    extensionFlag: action.response?.data.extension_flag,
    registration: action.response?.data.registration,
    driverlicense: action.response?.data.driverlicense,
    firstName: action.response?.data.firstName,
    lastName: action.response?.data.lastName,
    emailAddress: action.response?.data.emailAddress,
    originalReturnDate: action.response?.data.originalReturnDate,
    outLocation: action.response?.data.outLocation,
    locationName: action.response?.data.locationName,
    rentalType: action.response?.data.rentalType,
    loading: false,
  }),
  [types.RENTAL_LOGIN_FAILURE]: (state, error) => ({
    ...state,
    login: "failed",
    error: error,
    loading: false,
  }),
  [types.UPDATE_RETURN_DATE]: (state) => ({
    ...state,
    loading: true,
  }),
  [types.UPDATE_RETURN_DATE_SUCCESS]: (state, action) => ({
    ...state,
    updateNewReturnDate: action.response?.data,
    dateUpdateSuccess: true,
    loading: false,
  }),
  [types.UPDATE_RETURN_DATE_FAILURE]: (state, error) => ({
    ...state,
    error: error,
    loading: false,
  }),
  [types.RENTAL_ERROR_ALERT_OPEN]: (state, action) => ({
    ...state,
    errorAlert: true,
    errorMessage: action.payload.message,
  }),
  [types.RENTAL_ERROR_ALERT_CLOSE]: (state) => ({
    ...state,
    errorAlert: false,
    errorMessage: null,
  }),
  [types.SET_ELIGIBLE_FLAG]: (state, action) => ({
    ...state,
    eligibleFlag: action.payload.eligibleFlag,
  }),
});

export default rentalReducer;
